import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconPanelComponent } from './icon-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { IconPanelItemComponent } from './component/icon-panel-item/icon-panel-item.component';

@NgModule({
  declarations: [IconPanelComponent, IconPanelItemComponent],
  exports: [IconPanelComponent, IconPanelItemComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
})
export class IconPanelModule { }
